/**
 * YearLockBanner
 * Shows a read-only banner when the active performance year is locked.
 * Edits are also blocked server-side (403 + DB triggers); this is the UX signal.
 */
import { Lock } from 'lucide-react';
import { useProgramYear } from '@/contexts/ProgramYearContext';

export function YearLockBanner() {
  const { programYear, isCurrentYearLocked } = useProgramYear();

  if (!isCurrentYearLocked) return null;

  return (
    <div className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
      <Lock className="h-4 w-4 flex-shrink-0" />
      <span>
        <strong>Program year {programYear} is locked (read-only).</strong>{' '}
        Uploads, manual edits, score recalculation, settings, and goals are disabled for this year.
      </span>
    </div>
  );
}
